import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { getBoundActions } from '../../../actions/index'
import {
  ONBOARDING_COMPLETED_GA4_EVENT,
} from '../../../services/event-tracking/index'
import GaiaLogo, { TYPE_WHITE } from '../../GaiaLogo/GaiaLogo'
import DropInVideoPlayer, { BASIC_CONTROL_OPTIONS_VOLUME, BASIC_CONTROL_OPTIONS_VOLUME_LABEL } from '../../DropInVideoPlayer/index'
import ButtonProgress from '../../ButtonProgress/index'
import { H1 } from '../../Heading/index'
import AppStoreButtons, { MODES } from '../../AppStoreButtons/AppStoreButtons'

const FinalPage = (props) => {
  const {
    copy,
    isPractice,
    staticText,
    setEventDefault,
  } = props
  const mediaId = copy.get('onBoardingMediaId')
  const finalText = isPractice ? copy.get('finalStartPracticing') : copy.get('finalStartWatching')

  return (
    <div className="onboarding__final">
      <div className="onboarding__logo-container onboarding__final-logo-container">
        <GaiaLogo
          type={TYPE_WHITE}
          className={['onboarding__logo']}
        />
      </div>
      <div className="onboarding__final-content-wrapper">
        <div className="onboarding__title onboarding__final-text-container">
          <H1 className="onboarding__title onboarding__final-title">
            { copy.get('finalTitle') }
          </H1>
          <p className="onboarding__text onboarding__final-text">{copy.get('finalParagraph')}</p>
        </div>
        <div className="onboarding__video-container">
          <div className="onboarding__video-container-inner">
            <DropInVideoPlayer
              autoplay
              mediaId={mediaId}
              playsinline
              controls={{
                type: 'basic',
                visibleControls: [BASIC_CONTROL_OPTIONS_VOLUME, BASIC_CONTROL_OPTIONS_VOLUME_LABEL],
              }}
            />
          </div>
          <div className={'onboarding-final__button'}>
            <ButtonProgress
              progressText={staticText.get('buildingExperience')}
              completionText={finalText}
              completionUrl={'/'}
              completionClassName="onboarding__final--button"
              className="onboarding-final__progress-button"
              onClick={() => setEventDefault(ONBOARDING_COMPLETED_GA4_EVENT.mergeDeep({
                ui_location: 'onboarding',
              }))}
            />
          </div>
        </div>
      </div>
      <AppStoreButtons
        mode={MODES.APP_STORE_BUTTONS_DARK}
        text={staticText.get('appStoreButtonsText')}
      />
    </div>
  )
}

FinalPage.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  setEventDefault: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => ({
      user: state.user,
      userAccount: state.userAccount,
      staticText: state.staticText.getIn(['data', 'onboarding', 'data']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(FinalPage)
